<template>
  <div class="container">
    <el-page-header class="page-header" @back="goBack" :content="cTitle">
    </el-page-header>
    <div class="main" style="display: flex">
      <el-form ref="ruleForm" :model="form" :rules="rules" label-width="12.0rem" style="width: 80.0rem">
        <div class="form-header">
          <el-form-item prop="title" label="发送内容：">
            <el-input clearable v-model="form.title" placeholder="请输入内容" ></el-input>
          </el-form-item>
        </div>
        <div class="form-content">
          <el-form-item prop="type" label="内容类型：">
            <el-radio-group v-model="form.type" @change="changeType">
              <el-radio label="图片">图片</el-radio>
              <el-radio label="视频">视频</el-radio>
              <el-radio label="文件">文件</el-radio>
              <el-radio label="图文">图文</el-radio>
              <el-radio label="小程序">小程序</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item prop="linkTitle" v-if="form.type === '图文'" label="标题：">
            <el-input clearable v-model="form.linkTitle" placeholder="请输入图文标题"></el-input>
          </el-form-item>
          <el-form-item prop="link" v-if="form.type === '图文'" label="链接：">
            <el-input clearable v-model="form.link" placeholder="链接必须带有http或https协议，如：https://work.weijub.com"></el-input>
          </el-form-item>
          <el-form-item prop="file" v-if="
            form.type === '图文' ||
            form.type === '图片' ||
            form.type === '小程序'
          " :label="form.type === '图文' ? '封面' : form.type + '：'">
            <el-upload class="upload-demo" :action="
              this.axios.defaults.baseURL +
              '/api/Alioss/upload_temp_uploadimg'
            " :data="upParams" :on-preview="handlePreview" :on-remove="handleRemove"
              :before-upload="handleBeforeUpload" :on-success="handleSuccess" :on-error="handleError"
              :before-remove="beforeRemove" :on-exceed="handleExceed" :file-list="fileList" :list-type="listType"
              :accept="accept" :limit="1">
              <el-button type="primary" icon="el-icon-upload">
                上传{{
                  form.type === "图文" || form.type === "小程序"
                  ? "封面"
                  : form.type
                }}
              </el-button>

              <div slot="tip" class="el-upload__tip">{{ tip }}</div>
            </el-upload>
          </el-form-item>
          <el-form-item prop="file" v-if="
            form.type === '文件' ||
            form.type === '视频'
          " :label="form.type === '文件' ? '文件' : form.type + '：'">
            <el-upload class="upload-demo" :action="
              this.axios.defaults.baseURL +
              '/api/Alioss/upload_temp_uploadimg'
            " :show-file-list="false" :data="upParams" :on-preview="handlePreview" :on-remove="handleRemove"
              :before-upload="handleBeforeUpload" :on-success="handleSuccess" :on-error="handleError"
              :before-remove="beforeRemove" :on-exceed="handleExceed" :file-list="fileList" :list-type="listType"
              :accept="accept" :limit="1">
              <el-button type="primary" icon="el-icon-upload">
                上传{{ form.type === "文件" ? "文件" : form.type }}
              </el-button>
              <div slot="tip" class="el-upload__tip">{{ tip }}</div>
            </el-upload>
            <div class="el-upload__tip" v-show="loading2">
              上传中...<i class="el-icon-loading" style="color: #36a3f7; margin-left: 5px"></i>
            </div>
          </el-form-item>
          <el-form-item v-if="isShowVideo" label="">
            <div class="el-upload__tip">
              {{ form.file_name
              }}<i class="el-icon-upload-success el-icon-circle-check" style="color: green; margin-left: 5px"></i>
              <i class="el-icon-close" style="margin-left: 2.0rem;color:#188000" @click="removevideo"></i>
          </div>
            <div>
              <video style="width: 224px; height: 126px" :src="form.file" controls="controls"></video>
            </div>
          </el-form-item>
          <el-form-item v-if="isShowFile">
            <div class="el-upload__tip">
              {{ form.file_name
              }}<i class="el-icon-upload-success el-icon-circle-check" style="color: green; margin-left: 5px"></i>
              <i class="el-icon-close" style="margin-left: 2.0rem;color:#188000" @click="removeflie"></i>
          </div>
          </el-form-item>
          <el-form-item prop="desc" v-if="form.type === '图文' || form.type === '文本'" label="内容：">
            <el-input clearable type="textarea" autosize="true" v-model="form.desc" placeholder="请输入内容"></el-input>
          </el-form-item>
          <el-form-item prop="mini_name" v-if="form.type === '小程序'" label="小程序标题：">
            <el-input clearable v-model="form.mini_name" placeholder="请输入小程序标题"></el-input>
          </el-form-item>
          <el-form-item prop="mini_id" v-if="form.type === '小程序'" label="小程序ID：">
            <el-input clearable v-model="form.mini_id" placeholder="请输入小程序ID"></el-input>
          </el-form-item>
          <el-form-item :prop="link_url" v-if="form.type === '小程序'" label="小程序路径：">
            <el-input clearable v-model="form.link_url" placeholder="请输入小程序路径"></el-input>
          </el-form-item>
        </div>

        <div class="form-footer">
          <el-form-item label-width="45px">
            <el-button type="primary" :disabled="islock" @click="submitForm('ruleForm')"
              >{{buttonName}}</el-button
            >
            <!-- <el-button
              style="margin-left: 2.0rem"
              type=""
              plain
              @click="$router.back()"
              >取消</el-button
            > -->
          </el-form-item>
        </div>
      </el-form>
      <div class="con-right" :style="'background-image:url(' + backImg + ')'">
        <!-- <img
          class="mobile-img"
          src="../../../assets/smartPhone.png"
          alt=""
          srcset=""
        /> -->
        <div class="mobile">
          <div class="list">
            <!-- 发送内容 -->
            <div class="list-item" v-show="form.title">
              <div class="list-item-l">
                <img class="list-item-l-avatar" src="../../../assets/logoCircle.png" />
              </div>
              <div class="list-item-r" style="
                              width: 70%;
                              overflow: hidden;
                              text-overflow: ellipsis;
                              background: #fff;
                              padding: 5px;
                              border-radius: 4px;
                            ">
                {{ form.title }}
              </div>
            </div>
            <!-- 图片 -->
            <div class="list-item" v-show="form.type === '图片' && form.file != ''">
              <div class="list-item-l">
                <img class="list-item-l-avatar" src="../../../assets/logoCircle.png" />
              </div>
              <div class="list-item-r">
                <img :src="form.file" />
              </div>
            </div>
            <!-- 视频 -->
            <div class="list-item" v-show="form.type === '视频' && form.file != ''">
              <div class="list-item-l">
                <img class="list-item-l-avatar" src="../../../assets/logoCircle.png" />
              </div>
              <div class="list-item-r">
                <div class="list-item-r-u">
                  <video style="width: 13.0rem; height: 6.0rem" :src="form.file" controls="controls"></video>
                </div>
              </div>
            </div>
            <!-- 文件 -->
            <div class="list-item" v-show="form.type === '文件' && form.file != ''">
              <div class="list-item-l">
                <img class="list-item-l-avatar" src="../../../assets/logoCircle.png" />
              </div>
              <div class="list-item-r file">
                <div>{{ form.file_name }}</div>
                <div class="img">
                  <img src="../../../assets/文件 (2).png" alt="" />
                </div>
              </div>
            </div>
            <!-- 图文 -->
            <div class="list-item" v-show="form.type === '图文' && form.linkTitle != ''">
              <div class="list-item-l">
                <img class="list-item-l-avatar" src="../../../assets/logoCircle.png" />
              </div>
              <div class="list-item-b-a">
                <div style="width: 50%; margin-right: 1.0rem">
                  <div class="list-item-r-t">{{ form.linkTitle }}</div>
                  <div class="list-item-r-t">{{ form.link }}</div>
                  <div class="list-item-r-t">{{ form.desc }}</div>
                </div>
                <div class="list-item-r-d" v-if="form.file">
                  <img :src="form.file" />
                </div>
              </div>
            </div>
            <!-- 小程序 -->
            <div class="list-item" v-show="form.type === '小程序' && form.mini_name != ''">
              <div class="list-item-l">
                <img class="list-item-l-avatar" src="../../../assets/logoCircle.png" />
              </div>
              <div class="list-item-b-a">
                <div style="width: 10.0rem; margin-right: 1.0rem">
                  <div class="list-item-r-t" style="display: flex;align-items: center;">{{ form.mini_name }}
                    <img style="width: 1.1rem;margin-left: 5px;" src="../../../assets/小程序 (1).png" alt="">
                  </div>
                </div>
                <div class="list-item-r-d" v-if="form.file">
                  <img :src="form.file" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-image-viewer v-if="showViewer" :on-close="closeViewer" :url-list="[url]" />
  </div>
</template>
<script>
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
import axios from "axios";
import qs from "qs";
export default {
  components: { ElImageViewer },
  data() {
    return {
      islock: false,//控制按钮状态
      form: {
        title: "",
        type: "",
        desc: "",
        file: "",
        link: "",
        linkTitle: "",
        linkCover: "",
        media_id: "",
        mini_name: "",
        link_url: "/pages/page/index.html",
        mini_id: "",
        file_name: "",
      },
      rules: {
        title: [{ required: true, message: "请输入内容", trigger: "blur" }],
        desc: [{ required: true, message: "请输入内容", trigger: "blur" }],
        file: [{ required: true, message: "请选择文件", trigger: "blur" }],
        link: [{ required: true, message: "请输入链接", trigger: "blur" }],
        linkTitle: [
          { required: true, message: "请输入图文标题", trigger: "blur" },
        ],
        linkCover: [{ required: true, message: "请选择文件", trigger: "blur" }],
        mini_name: [
          { required: true, message: "请输入小程序标题", trigger: "blur" },
        ],
        mini_id: [
          { required: true, message: "请输入小程序appID", trigger: "blur" },
        ],
        link_url: [
          { required: true, message: "请输入小程序页面路径", trigger: "blur" },
        ],
      },
      fileList: [],
      // 上传图片地址
      imageUrl: "",
      disabled: false,
      accept: "",
      listType: "",
      tip: "",
      tooken: null,
      upParams: {},
      showViewer: false, // 显示查看器
      url: "",
      loading2: false,
      backImg: require("@/assets/smartPhone.png"),
      cTitle: "",
      buttonName:''
    };
  },
  computed: {
    isShowVideo() {
      return this.form.type === "视频" && this.form.file.length > 0;
    },
    isShowFile() {
      return this.form.type === "文件" && this.form.file.length > 0;
    },
  },
  mounted() {
    if (window.localStorage.getItem("storuser")) {
      let userinfo = JSON.parse(window.localStorage.getItem("storuser"));
      this.tooken = userinfo;
      this.upParams.account_id = this.tooken.account_id;
    }
    if (!this.$route.query.id) {
      this.cTitle = "新建素材"
      this.buttonName="立即创建"
      this.form.type = "";
      return;
    } else {
      this.cTitle = "编辑素材"
      this.buttonName="确认修改"
    }
    this.getData();
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    onPreview(url) {
      this.url = url;
      this.showViewer = true;
    },
    // 关闭查看器
    closeViewer() {
      this.url = "";
      this.showViewer = false;
    },
    getData() {
      this.axios
        .post(
          "/crm/GroupMaterial/getMaterialOne",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            id: this.$route.query.id,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.code == 1) {
            const data = res.data.data;
            this.form.desc = data.content;
            this.form.linkTitle = data.link_title;
            this.form.link = data.link_url;
            this.form.title = data.title;
            this.form.type = data.type;
            this.form.file = data.url;
            this.form.media_id = data.media_id;
            this.form.link_url = data.link_url;
            this.form.mini_name = data.mini_name;
            this.form.mini_id = data.mini_id;
            this.form.file_name = data.file_name;
            let fileObj = {}
            if (data.type == '图片') {
              fileObj = {
                url: data.url,
              };
            } else {
              fileObj = {
                url: data.url,
                name: data.file_name,
              };
            }
            this.fileList.push(fileObj);
            this.setAccept();
          } else if (res.data.code == 0) {
            this.$message.error(res.data.msg);
          }
        })
        .catch(function (err) { });
    },
    changeType() {
      this.form.desc = "";
      this.form.file = "";
      this.form.media_id = "";
      this.fileList = [];
      this.form.link = "";
      this.form.linkTitle = "";
      this.form.linkCover = "";
      this.form.mini_name = "";
      this.form.mini_id = "";
      this.form.file_name = "";
      this.setAccept();
    },
    setAccept() {
      switch (this.form.type) {
        case "图片":
          this.listType = "picture";
          this.tip = "只能上传JPG,PNG格式文件，且不超过2MB";
          this.accept = ".jpg,.png";
          this.upParams.type = 1;
          break;
        case "视频":
          this.listType = "text";
          this.tip = "只能上传MP4格式文件，且不超过10MB";
          this.accept = ".mp4";
          this.upParams.type = 2;
          break;
        case "文件":
          this.listType = "text";
          this.tip = "不能超过20MB";
          this.accept = "";
          this.upParams.type = 3;
          break;
        case "图文":
          this.listType = "picture";
          this.tip = "只能上传JPG,PNG格式文件，且不超过2MB";
          this.accept = ".jpg,.png";
          break;
        case "小程序":
          this.listType = "picture";
          this.tip = "只能上传JPG,PNG格式文件，且不超过2MB";
          this.accept = ".jpg,.png";
          break;
        default:
          break;
      }
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      if (
        this.form.type === "图片" ||
        this.form.type === "图文" ||
        this.form.type === "小程序"
      ) {
        let url = "";
        if (this.$route.query.id) {
          url = file.url;
        } else {
          url = file.response.data.url;
        }
        this.onPreview(url);
      }
    },
    handleExceed(files, fileList) { },
    handleBeforeUpload(file) {
      const size = file.size / 1024 / 1024;
      if (
        this.form.type === "图片" ||
        this.form.type === "图文" ||
        this.form.type === "小程序"
      ) {
        if (size > 2) {
          this.$message({
            message: "上传图片文件过大",
            type: "error",
          });
          return false;
        }
      }
      if (this.form.type === "视频") {
        this.loading2 = true;
        if (size > 10) {
          this.$message({
            message: "上传视频文件过大",
            type: "error",
          });
          return false;
        }
      }
      if (this.form.type === "文件") {
        this.loading2 = true;
        if (size > 20) {
          this.$message({
            message: "上传文件过大",
            type: "error",
          });
          return false;
        }
      }
    },
    handleSuccess(response, file, fileList) {
      this.loading2 = false;
      if (response.code == 0) {
        this.$message({
          message: response.msg,
          type: "error",
        });
        this.form.file = "";
        this.form.media_id = "";
        this.fileList = [];
        this.form.file_name = "";
        return;
      }
      this.$message({
        message: response.msg,
        type: "success",
      });
      this.form.file = response.data.url;
      this.form.media_id = response.data.media_id;
      this.form.file_name = response.data.urlname;
      this.fileList.push(this.form.url);
    },
    handleError(response) {
      this.$message({
        message: response.msg,
        type: "success",
      });
    },
    beforeRemove(file, fileList) {
      this.form.file = [];
      this.fileList = [];
    },
    handleRemove(file) {
      console.log(file);
    },
    handleDownload(file) {
      console.log(file);
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.islock = true
          this.submit();
          setTimeout(() => {
            this.islock = false
          }, 1000)
        } else {
          return false;
        }
      });
    },
    submit() {
      // if (this.form.link == "") {
      //   this.form.link = this.form.link_url;
      // }
      const url = this.$route.query.id ? "editMaterial" : "addMaterial";
      this.axios
        .post(
          `/crm/GroupMaterial/${url}`,
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            template_id: this.$route.query.template_id,
            type: this.form.type,
            content: this.form.desc,
            title: this.form.title,
            url: this.form.file,
            media_id: this.form.media_id,
            link_url: this.form.link,
            link_title: this.form.linkTitle,
            describe: this.form.desc,
            mini_name: this.form.mini_name,
            mini_id: this.form.mini_id,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.code == 1) {
            this.$message.success(res.data.msg);
            this.$router.go(-1);
          } else if (res.data.code == 0) {
            this.$message.error(res.data.msg);
          }
        })
        .catch(function (err) { });
    },
    removeflie(){
      this.$confirm("是否删除该文件?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(()=>{
      this.form.file_name=''
      this.form.file=''
      this.fileList=[]
      }).catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    removevideo(){
      this.$confirm("是否删除该视频?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(()=>{
        this.form.file_name=''
      this.form.file=''
      this.fileList=[]
      }).catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });

    },
  },
};
</script>
<style scoped>
::v-deep .el-link.el-link--primary {
  display: inline-block;
  width: 100%;
}

.header {
  line-height: 4.0rem;
  border-bottom: .1rem solid rgb(241, 239, 239);
}

.main {
  margin-top: .0rem;
}

.form-header,
.form-content {
  /* border: .1rem solid #e9e9e9; */
  padding-top: 4.0rem;
  padding-right: 22px;
  overflow: hidden;
  padding-left: 2.0rem;
}

.form-content{
  padding-top: .0rem;
}

/* .form-content, */
.form-footer {
  margin-top: 2.0rem;
}
.el-form-item {
    margin-bottom: 4.0rem;
}

.el-upload-list__item-thumbnail {
  width: 10.0rem;
  height: 10.0rem;
}

.con-right {
  width: 375px;
  margin-left: 20.0rem;
  height: 642px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.mobile {
  position: relative;
  top: 11.0rem;
  left: 45px;
  width: 70%;
}

.mobile-img {
  width: 19.59%;
  position: absolute;
}

.list-item {
  display: flex;
  margin: 1.0rem 15px;
}

.list-item-l {
  margin-right: 6px;
}

.list-item-l img {
  width: 4.0rem;
  border-radius: 50%;
}

.list-item-r,
.list-item-b-a {
  color: #666;
  font-size: 12px;
}

.list-item-b-a {
  background: #fff;
  border: .1rem solid #eee;
  padding: 1.0rem;
  border-radius: 4px;
  display: flex;
  align-items: center;
}

.list-item-r img {
  width: 84%;
}

.list-item-r-d img {
  width: 84%;
  height: 5.0rem;
}

.list-item-r-t {
  line-height: 1.5;
}

.list-item-b-a .list-item-r-t {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.file {
  width: 70%;
  overflow: hidden;
  text-overflow: ellipsis;
  background: #fff;
  padding: 5px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.file img {
  width: 100%;
}

.img {
  width: 4rem;
  height: 4.5rem;
  background: #409eff;
  border-radius: 4px;
  text-align: center;
}
.el-input,
.el-textarea{
  width: 47rem;
}

.el-page-header {
    position: relative;
    top: -0.4rem;
}
.main{
  background-color: #fff;
  border-radius: 0.8rem;
}
.el-form-item__label{
  font-size: 16px;

}
</style>
